var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FFBB5C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_925_446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8066 4.55585C23.8066 4.55585 23.8066 38.6765 23.8066 40.672C23.8066 42.6675 24.9267 43.4874 26.2051 43.4874C27.4836 43.4874 28.712 42.5674 28.712 40.8249V40.0995",
    stroke: "white",
    strokeWidth: 1.11169,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2668 23.0989C36.2668 23.0989 36.339 17.5015 33.4347 13.077C30.5304 8.65244 27.8902 7.29617 23.8075 6.06775C23.8075 6.06775 30.5193 5.43131 37.1784 11.2788C43.8374 17.1263 43.0259 23.4018 43.0259 23.4018C43.0259 23.4018 42.181 22.3707 40.0743 22.3513C37.7481 22.3291 36.264 23.0989 36.264 23.0989C36.264 23.0989 33.7988 21.4564 29.5799 21.4564C25.3611 21.4564 23.8047 22.7626 23.8047 22.7626",
    stroke: "white",
    strokeWidth: 1.11169,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3497 23.0989C11.3497 23.0989 11.2774 17.5015 14.1817 13.077C17.086 8.65244 19.7263 7.29617 23.809 6.06775C23.809 6.06775 17.0971 5.43131 10.4381 11.2788C3.77625 17.1291 4.58779 23.4046 4.58779 23.4046C4.58779 23.4046 5.43267 22.3735 7.53933 22.3541C9.86555 22.3318 11.3497 23.1017 11.3497 23.1017C11.3497 23.1017 13.8148 21.4592 18.0337 21.4592C22.2526 21.4592 23.809 22.7654 23.809 22.7654",
    stroke: "white",
    strokeWidth: 1.11169,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_925_446"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.6152,
    height: 40.0432,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUi);
export default __webpack_public_path__ + "static/media/UI.f637ddf67578000b87d5d9930853540a.svg";
export { ForwardRef as ReactComponent };